__turbopack_context__.v({
  "container": "Header-module-scss-module__Jp4h2q__container",
  "hasGeneralBanner": "Header-module-scss-module__Jp4h2q__hasGeneralBanner",
  "headerHidden": "Header-module-scss-module__Jp4h2q__headerHidden",
  "headerStack": "Header-module-scss-module__Jp4h2q__headerStack",
  "navbarShrinked": "Header-module-scss-module__Jp4h2q__navbarShrinked",
  "navbarWrapper": "Header-module-scss-module__Jp4h2q__navbarWrapper",
  "spacer": "Header-module-scss-module__Jp4h2q__spacer",
  "wrapper": "Header-module-scss-module__Jp4h2q__wrapper",
});
